import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { BulkStatusCounts } from '@/stores/bulkCreationStore';

export interface PairingStatusLineProps {
  counts: BulkStatusCounts;
  className?: string;
}

/**
 * "X Front · Y Back → Z Designs" (R18) with the notes below it: designs with
 * only one side once any back was uploaded, and backs that no active product
 * can take.
 */
export function PairingStatusLine({
  counts,
  className,
}: PairingStatusLineProps) {
  const { t } = useTranslation();
  const showIncomplete = counts.backCount > 0 && counts.incompletePairs > 0;

  return (
    <div
      aria-live="polite"
      data-testid="bulk-pairing-status"
      className={cn('flex flex-col gap-1', className)}
    >
      <p className="font-mono text-[13px] font-medium text-ink">
        {t('seller.bulk.motifs.status', {
          front: counts.frontCount,
          back: counts.backCount,
          designs: counts.designCount,
        })}
      </p>
      {showIncomplete && (
        <p className="text-sm text-ink-2">
          {t('seller.bulk.motifs.incompletePairs', {
            count: counts.incompletePairs,
          })}
        </p>
      )}
      {counts.backIgnored && (
        <p className="text-sm text-warning">
          {t('seller.bulk.motifs.backIgnoredNotice')}
        </p>
      )}
    </div>
  );
}
